import { Command, HttpMethod } from "~/extensions/api";
export class FindTaikyoNotificationForInput extends Command {
    constructor() {
        super(HttpMethod.Post, "taikyonotification/forInput");
    }
    /** 入居契約No. */
    orgNyukyokeiyakuNoList = [];
    static create(orgNyukyokeiyakuNoList) {
        const command = new FindTaikyoNotificationForInput();
        command.orgNyukyokeiyakuNoList = orgNyukyokeiyakuNoList;
        return command;
    }
}
